import { useSoyuzData } from '@spotahome/soyuz/client';

import {
  ThemeProvider,
  FooterSimplified,
  UserInfoProvider,
  GenericErrorContent
} from '@spotahome/ui-library';

import LoginModal from './components/LoginModal';
import HeaderContainer from './components/HeaderContainer';

import './scss/init.scss';

const GenericErrorPage = () => {
  const { [GenericErrorPage.NAME]: requestedData } = useSoyuzData();
  const { errorType = 'clientError' } = requestedData.query;

  let title;
  if (errorType === 'notFound') {
    title = 'error_page.not_found.h1.new';
  }

  return (
    <ThemeProvider flags={{ newButtons: true }}>
      <UserInfoProvider>
        <HeaderContainer />
        <GenericErrorContent title={title} />
        <FooterSimplified />
        <LoginModal />
      </UserInfoProvider>
    </ThemeProvider>
  );
};

GenericErrorPage.NAME = 'GenericErrorPage';

GenericErrorPage.requestAllData = req => {
  return {
    data: {
      query: req.query
    }
  };
};

export default GenericErrorPage;
